import { Component } from '@angular/core';
import { ConstantsTextsView } from '@app/shared/interfaces/constant-texts';
import json from '@app/shared/interfaces/constant-texts.json';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  text: ConstantsTextsView = {} as ConstantsTextsView;

  constructor() {
    this.text = json as ConstantsTextsView;
  }
}
